export const STATUS_CODES = {
    SUCCESS: 200,
    CREATED: 201,
    LIMIT_EXCEED: 220,
    TRIALEND: 221,
    UNVERIFIED: 401,
    BAD_REQUEST: 400,
    INTERNAL_SERVER_ERROR: 500,
}

